export default "__VITE_ASSET__BLWmZUYn__"